<template>
  <div>
    <div class="input-right">
      <div class="input-search">
        <input v-model="searchValue" type="text" placeholder="搜索相关内容" :listData="listData" />
        <div class="search-word" @click="changeValue(page)">搜索</div>
      </div>
    </div>
  </div>
</template>
<script>
import defaultList from './defaultList';
export default {
  components: {
    defaultList
  },
  props: {
    searchNavValue: String
  },
  data () {
    return {
      defaultBool: false,
      searchValue: '',
      listParams: {},
      page: {
        currPage: 1,
        pageSize: 10
      },
      listData: [
        {
          id: '1',
          name: '计量'
        },
        {
          id: '2',
          name: '标准'
        },
        {
          id: '3',
          name: '认证认可'
        },
        {
          id: '4',
          name: '检验检测'
        },
        {
          id: '5',
          name: '认证机构'
        }
      ]
    };
  },
  mounted () {
    this.searchValue = this.$store.state.searchInputValue;
  },
  methods: {
    pushRouter () {
      this.$store.commit('saveIsHot', false)
      this.$router.push({ path: '/commonList' })
    },
    changeValue (page, fromPage) {
      this.currentValue = this.$store.state.currentFilterValue;
      this.$store.commit('saveSearchInputValue', this.searchValue);
      if (this.$store.state.currentFilterValue !== '计量' && this.$store.state.currentFilterValue !== '标准' && this.$store.state.currentFilterValue !== '认证认可' && this.$store.state.currentFilterValue !== '检验检测') {
        localStorage.setItem('filterValue', '计量')
        this.$store.commit('saveFilterValue')
      }
      this.defaultBool = false;
      let url = '';
      switch (this.$store.state.currentFilterValue) {
        case '计量':
          url = '/cal/calOrgan/list';
          break;
        case '标准':
          url = '/sta/sta/list';
          break;
        case '认证认可':
          url = '/cer/cerOrgan/list';
          break;
        case '检验检测':
          url = '/ins/insOrgan/list';
          break;
        default:
          url = 'select-none';
          break;
      }
      if (this.$store.state.activeShow === '服务能力') {
        url = '/cal/technicalCapacity/list';
      }
      if (this.$store.state.searchInputValue || this.searchNavValue) {
        this.listParams.name = this.$store.state.searchInputValue || this.searchNavValue;
      } else {
        if (this.listParams) {
          if (this.listParams.name) {
            delete this.listParams.name;
          }
        }
      }
      this.getData(url, page || {currPage: 1,
        pageSize: 10}, fromPage)
    },
    tranColor (name) {
      var str = '';
      for (var i = 0; i < name.length; i++) {
        str += parseInt(name[i].charCodeAt(0), 10).toString(16);
      }
      return 'background:' + '#' + str.slice(1, 4);
    },
    getData (url, page, fromPage) {
      // if (fromPage) {
      //   this.listParams = this.$store.state.listParams
      // }
      if (url === '/sta/sta/list') {
        let item = this.$store.state.activeShow
        if (item === '国家标准') {
          this.listParams.category = '2';
        }
        if (item === '行业标准') {
          this.listParams.category = '3';
        }
      }
      this.verify(
        'post',
        url,
        { query: this.listParams ? this.listParams : {}, page },
        res => {
          this.normalListData = res.data.list;
          res.data.list.forEach(element => {
            if (element.name || element.organName) {
              element.color = this.tranColor(element.name ? element.name : element.organName)
            }
          });
          this.pushRouter()
          this.$store.commit('saveNormalListData', res.data.list);
          this.$store.commit('saveNormalListDataPage', res.data.page)
        }
      );
    }
  },
  created () {},
  computed: {},
  watch: {}
};
</script>
<style lang="less" scoped>
.input-right {
  overflow: hidden;
  display: inline-block;
  .input-search {
    position: absolute;
    right: 36px;
    top: 22px;
    input {
      width: 320px;
      height: 60px;
      border: 1px solid rgba(0, 0, 0, 0.14);
      border-right: none;
      padding-left: 20px;
      font-size: 14px;
      font-weight: 400;
      float: left;
      color: rgba(0, 0, 0, 1);
    }
    .search-word {
      width: 100px;
      line-height: 60px;
      background: @color-base;
      text-align: center;
      display: inline-block;
      font-size: 16px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
  }
  .search-details {
    width: 419px;
    height: 244px;
    position: absolute;
    right: 36px;
    top: 82px;
    // background:#fff;
    // box-shadow:0px 8px 10px 0px rgba(0,141,255,0.1);
    ul li {
      line-height: 34px;
      font-size: 14px;
      font-weight: 400;
      color: @color-base;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/searchList.vue